import React from 'react';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import {
  StaticDateRangePicker as DatePicker,
  LocalizationProvider,
  DateRangePickerDay,
} from '@mui/lab';
import { IconButton } from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import { GRAY_BACKGROUND_2, PRIMARY_BLUE } from '~/Constants/Colors.constants';
import cn from 'classnames';

const useStyles = makeStyles({
  rightArrow: {
    top: '-292px',
  },
  isHighlighting: {
    backgroundColor: GRAY_BACKGROUND_2,
  },
  selected: {
    backgroundColor: GRAY_BACKGROUND_2,
    button: {
      backgroundColor: PRIMARY_BLUE,
      '&:hover': {
        backgroundColor: `${PRIMARY_BLUE} !important`,
      },
      '&:focus': {
        backgroundColor: `${PRIMARY_BLUE} !important`,
      },
    },
  },
  rangePickerContainer: {
    '& .MuiTypography-caption.MuiTypography-root': {
      width: 32,
      height: 32,
    },
    '& .PrivatePickersSlideTransition-root': {
      minWidth: 300,
      minHeight: 230,
    },
    'div :has(.PrivatePickersSlideTransition-root)': {
      border: 'none',
    },
  },
});

export function StaticRangePicker({
  value,
  handleDateChange,
  open,
  isMobile,
  disableFuture,
  disablePast,
}: any) {
  const { classes } = useStyles();
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        displayStaticWrapperAs="desktop"
        value={value}
        onChange={handleDateChange}
        onClose={() => {}}
        open={open}
        disableFuture={disableFuture}
        disablePast={disablePast}
        renderInput={() => <div />}
        className={classes.rangePickerContainer}
        disableAutoMonthSwitching
        renderDay={(date: Date, pickersDayProps: any) => {
          const {
            selected,
            isHighlighting,
            outsideCurrentMonth,
            isStartOfHighlighting,
            isEndOfHighlighting,
          } = pickersDayProps;
          let className = pickersDayProps.className;

          if (selected && !outsideCurrentMonth) {
            if (!isStartOfHighlighting && !isEndOfHighlighting) {
              pickersDayProps['isStartOfHighlighting'] = true;
              pickersDayProps['isEndOfHighlighting'] = true;
            }

            className = cn(className, classes.selected);
          } else if (isHighlighting && !outsideCurrentMonth) {
            className = cn(className, classes.isHighlighting);
          }

          return <DateRangePickerDay date={date} {...pickersDayProps} className={className} />;
        }}
        components={{
          // eslint-disable-next-line react/no-multi-comp
          RightArrowButton: (props: any) => (
            <IconButton
              {...props}
              className={isMobile ? cn(props.className, classes.rightArrow) : props.className}
            />
          ),
        }}
      />
    </LocalizationProvider>
  );
}
